import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const gradesAssess = {
    assessmentList: {
        list: config => createAPI('/skillRecognition/pdmd/list', 'post', config),
        summaryStatisticslist: config => createAPI('/skillRecognition/pdmd/summaryStatisticslist', 'post', config),
        initCombo: config => createAPI('/skillRecognition/pdmd/initCombo', 'post', config),
        editCjdj: config => createAPI('/skillRecognition/pdmd/editCjdj', 'post', config),
        queryKskc: config => createAPI('/skillRecognition/pdmd/queryKskc', 'post', config),
        editTgzt: config => createAPI('/skillRecognition/pdmd/editTgzt', 'post', config),
        batchExport: config => createAPI('/skillRecognition/pdmd/batchExport', 'post', config),
        queryDzzsInfo: config => createAPI('/skillRecognition/pdmd/queryDzzsInfo', 'post', config),
    },
    transcripts: {
        list: config => createAPI('/skillRecognition/cjpdcjd/list', 'post', config),
        initOption: config => createAPI('/skillRecognition/cjpdcjd/initOption', 'post', config),
        batchExport: config => createAPI('/skillRecognition/cjpdcjd/batchExport', 'post', config),

    },
};


export default gradesAssess;



// WEBPACK FOOTER //
// ./src/api/modules/gradesAssess.js